import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ai' | 'ghost' | 'danger';

const styles: Record<Variant, string> = {
  primary: 'btn-primary-gradient text-white shadow-[0_8px_24px_rgba(0,102,255,0.35)]',
  secondary: 'border border-white/12 bg-white/[0.06] text-[var(--text-secondary)] hover:bg-white/[0.1]',
  ai: 'btn-ai-gradient text-white shadow-[0_8px_24px_rgba(139,92,246,0.35)]',
  ghost: 'text-[var(--text-muted)] hover:bg-white/[0.06] hover:text-[var(--text-secondary)]',
  danger: 'border border-red-500/30 bg-red-500/10 text-red-300 hover:bg-red-500/15',
};

export function PrimaryButton({
  children,
  variant = 'primary',
  className = '',
  fullWidth,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: Variant;
  fullWidth?: boolean;
}) {
  return (
    <button
      {...props}
      type={props.type ?? 'button'}
      className={`btn-press inline-flex min-h-[52px] items-center justify-center rounded-2xl px-5 text-[15px] font-semibold transition-[transform,opacity,box-shadow] duration-200 disabled:opacity-50 ${styles[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      {children}
    </button>
  );
}

/** @deprecated use PrimaryButton */
export const ActionButton = PrimaryButton;
